import React, { useState, useEffect } from 'react';
import { ref, onValue, push ,set} from 'firebase/database';
import { db,auth } from '../../../../FirebaseConfig';
import { nanoid, customAlphabet } from 'nanoid';
import { getUsersOrganizations } from '../../../../api/organization';
import './QueueCreate.css';
import { useNavigate } from "react-router-dom";
import Toast from '../../../common/Toast';
import { Spinner } from 'react-bootstrap';


const QueueCreate = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [createdOn, setCreatedOn] = useState('');
  const [limit, setLimit] = useState('');
  const [value, setValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user, setUser] = useState(null)
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  // State for holding organizations and selected organization
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState('');

  // Fetch organizations when the component mounts
    useEffect(() => {
    let currentUser = auth.currentUser;
    if(window.Cypress) {
      currentUser = { uid: 'test-user', email: 'test@example.com' };
      setUser(currentUser);
      getUsersOrganizations(currentUser.uid)
        .then((userOrganizations) => setOrganizations(userOrganizations))
        .catch(console.error)
        .finally(() => setIsLoading(false));
    } else if (currentUser) {
      setUser(currentUser)
      getUsersOrganizations(currentUser.uid).then((userOrganizations) => {
        setOrganizations(userOrganizations);
      }).catch(error => {
        console.error("Error fetching organizations:", error);
      }).finally(() => {
        setIsLoading(false); // Stop loading whether success or error
      });
  } else {
    setIsLoading(false); // No user, still need to stop loading
  }
    // Set today's date as createdOn
      const today = new Date().toISOString().split('T')[0]; 
      setCreatedOn(today); 
    }, []);

  const handleAddQueue = async (e) => {
    e.preventDefault();

    const queueLimit = limit && Number(limit) > 0 ? Number(limit) : "Unlimited";

    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const generateQueueID = customAlphabet(alphabet, 8);
    const queueId = generateQueueID(); 
    const userId = auth.currentUser ? auth.currentUser.uid : null;
    const hostName = auth.currentUser ? auth.currentUser.email : ''; 
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0]; 
    set(ref(db, 'queues/' + queueId), {
      id: queueId,
      name: name,
      description: description,
      createdOn: formattedDate, 
      userId:userId,
      hostId:hostName,
      limit: queueLimit,
      status: value,
      organizationId: selectedOrganization,

    })
         .then(() => {
         
          setIsModalOpen(true);  

          setName('');
          setDescription('');
          setCreatedOn('');
          setLimit('');
          setValue('');
          setSelectedOrganization('');
     })
     .catch(error => {
      console.error('Error creating queue: ', error);
      alert('Error creating queue. Please try again.');
   });
};
const handleCloseModal = () => {
  setIsModalOpen(false);
  navigate("/dashboard/queue/list");  
};

if (isLoading) {
  return (
    <div className="spinnerWrapper">
      <Spinner animation="border" className="customSpinner" />
        <span>Loading Page...</span>
    </div>
  );
}
if (!user){
  return(
    <Toast
    title="Temporary warning!"
    subTitle="Please sign up to work on this page."
  />
  )
}

return (
  <div>
    <h4>Create Queue</h4>
  <div className="queue-container">
    <form onSubmit={handleAddQueue}>
      <div className="input-container">
        <div>
          <label>Queue Name <span style={{ color: 'red' }}>*</span></label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter name"
            required
          />
        </div>
        <div>
          <label>Queue Description <span style={{ color: 'red' }}>*</span></label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter Description"
            rows="4"
            cols="54"
            required
          ></textarea>
        </div>

        <div>
          <label>Queue Limit </label>
          <input
            type="number"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
            placeholder="Enter limit (leave blank for Unlimited)"
            min="1"
          />
        </div>
        <div>
          <label>Queue Status <span style={{ color: 'red' }}>*</span></label>
          <select
            value={value}
            onChange={(e) => setValue(e.target.value)}
            required
          >
            <option value="">Select Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
        {/* Organization Dropdown */}
        <div>
            <label>Select Your Organization </label>
            <select
              value={selectedOrganization}
              onChange={(e) => setSelectedOrganization(e.target.value)}
            >
              <option value="">Select Organization</option>
              
                {window.Cypress ? (
                  // Тестовые данные, если это Cypress
                  <>
                    <option value="org1">Test Organization 1</option>
                    <option value="org2">Test Organization 2</option>
                  </>
                ) : (
              organizations.map((org) => (
                <option key={org.id} value={org.id}>
                  {org.orgName}
                </option>
              )))}
            </select>
          </div>

        <button type="submit" className="button">Create Queue</button>
      </div>
    </form>
    
      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Success</h2>
            <p>Queue created successfully!</p>
            <button onClick={handleCloseModal} className="button">OK</button>
          </div>
        </div>
      )}
    </div>
    </div>

);
};

export default QueueCreate;